import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { FailureMechanismTemplate } from './failureMechanismTemplate.slice';
import styles from './FailureMechanismTemplate.module.scss';
import { isStringNullOrEmpty } from '../Annotation/AnnotationForm/Utils';

type Props = {
  loading: boolean;
  selectedFailureMechanismTemplate?: FailureMechanismTemplate;
  onHideModal: () => void;
  onSubmit: (template: FailureMechanismTemplate) => void;
};

const FailureMechanismTemplateForm = ({ loading, selectedFailureMechanismTemplate, onHideModal, onSubmit }: Props) => {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (selectedFailureMechanismTemplate) {
      setCode(selectedFailureMechanismTemplate.code);
      setName(selectedFailureMechanismTemplate.name);
      setDescription(selectedFailureMechanismTemplate.description);
    }
    return () => {
      setCode('');
      setName('');
      setDescription('');
    };
  }, [selectedFailureMechanismTemplate]);

  const handleSubmit = () => {
    const model: FailureMechanismTemplate = {
      id: selectedFailureMechanismTemplate?.id,
      code,
      name,
      description,
      canDelete: false,
      canUpdate: false,
      deprecated: false
    };
    onSubmit(model);
  };

  const disabled = isStringNullOrEmpty(code) || isStringNullOrEmpty(name);
  const canRename = !selectedFailureMechanismTemplate || (selectedFailureMechanismTemplate && selectedFailureMechanismTemplate.canUpdate);

  return (
    <Modal
      title='Failure Mechanism Template'
      visible={true}
      onCancel={onHideModal}
      footer={[
        <Button key='save' onClick={handleSubmit} loading={loading} disabled={disabled}>
          Save
        </Button>,
        <Button key='back' onClick={onHideModal}>
          Cancel
        </Button>
      ]}
    >
      <div>
        <Form.Item label='Code' className={styles.antFormItem} required>
          <Input readOnly={!canRename} placeholder='Enter code' value={code} onChange={e => setCode(e.target.value)} />
        </Form.Item>
        <Form.Item label='Name' className={styles.antFormItem} required>
          <Input readOnly={!canRename} placeholder='Enter name' value={name} onChange={e => setName(e.target.value)} />
        </Form.Item>
        <Form.Item label='Description' className={styles.antFormItem}>
          <Input.TextArea
            placeholder='Enter description'
            value={description}
            onChange={e => {
              setDescription(e.target.value);
            }}
          />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default FailureMechanismTemplateForm;
